export default __webpack_public_path__ + "static/media/doctor-2.bc5c89f4.jpg";